export function hash(value: string): number {
  let hashValue = 5381;
  let i = value.length;

  while (i) {
    hashValue = (hashValue * 33) ^ value.charCodeAt(--i);
  }

  return hashValue;
}
